import fetchClient from '../components/common/FetchClient';

const requestType = 'REQUEST_PRICE_MATRIX_MODE';
const getPriceMatrixType = 'GET_PRICE_MATRIX_MODE';
const errorResp = 'ERROR_RESP';

const initialState = {
    priceMatrix: [],
    saveMessage: ''
};

export const actionCreators = {
    selectMatrixRating: data => async (dispatch, getState) => {

        var matrixGroup = data[0].replace("R1", "");
        matrixGroup = matrixGroup.replace("R2", "");
        matrixGroup = matrixGroup.replace("R3", "");

        data[1].forEach(group => {
            group.Rate.forEach(rating => {
                if (rating.MatrixId.includes(matrixGroup)) {
                    rating.CurrentlyAssigned = "0";
 
                    if (data[0] === rating.MatrixId) {
                        rating.CurrentlyAssigned = "1";
                    }
                    
                }
            })

        });

        var matrixResp = data[1];

        dispatch({
            type: getPriceMatrixType,
            matrixResp
        })
    }
    ,
    queryPriceMatrix: queryData => async (dispatch, getState) => {

        dispatch({ type: requestType });

        const url = `/api/PriceMatrix/PriceRateRequest`;

        fetchClient(url, {
            params: {
                azureToken: '',
                customerId: localStorage.getItem('customer'),
            }})
            .then(function (resp) {
                if (resp) {
                    
                    var matrixResp = resp.data.PriceRateGroupResp.PriceRateGroup;

                    var status = 'Matrix values retrieved!';

                    dispatch({
                        type: getPriceMatrixType,
                        matrixResp,
                        status
                    });
                }
            });
    }
    ,
    querySetPriceMatrix: queryData => async (dispatch, getState) => {

        dispatch({ type: requestType });

        console.log(queryData);

        const url = `/api/PriceMatrix/PriceRateRequest`;

        fetchClient(url, {
            params: {
                azureToken: '',
                customerId: localStorage.getItem('customer'),
                setPriceRate: true,
                updateData: JSON.stringify(queryData)
            }
        }).then(function (resp) {
            if (resp) {

                var matrixResp = resp.data.PriceRateGroupResp.PriceRateGroup;

                console.log(matrixResp);

                var status = 'Matrix values saved!'

                dispatch({
                    type: getPriceMatrixType,
                    matrixResp,
                    status
                });
            }
        }).catch(function (error) {
            var status = 'Error! The Matrix values could not be saved. ';

            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                status += 'The request was made and the server responded with a status code that falls out of the range of 2xx. Please email this error message to help.desk@empirepaper.com';
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                status += 'The request was made but no response was received. Please email this error message to help.desk@empirepaper.com';
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                status += error.message + '. Please email this error message to help.desk@empirepaper.com';
            }

            dispatch({
                type: errorResp,
                status
            })
        });
    },

};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === getPriceMatrixType) {
        return {
            ...state,
            priceMatrix: action.matrixResp,
            isLoading: false,
            saveMessage: action.status
        };
    }

    if (action.type === requestType) {

        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === errorResp) {

        return {
            ...state,
            saveMessage: action.status
        }
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/PriceMatrix.js